import * as React from 'react'
import './um-okkur-employees.css'

export default class UmOkkurEmployees extends React.Component<any> {
  constructor(props: any) {
    super(props)
    this.state = {}
  }

  render() {
    let content = this.props.content
    if (content != null) {
      content = content.sort((a: any, b: any) =>
        a.fields.order > b.fields.order
          ? 1
          : b.fields.order > a.fields.order
          ? -1
          : 0,
      )
    }

    return (
      <div className="um-okkur-staff-container ">
        <div className="item-container block">
          <div className="um-okkur-staff-single-container">
            {content !== undefined &&
              Object.keys(content).map(key => {
                const image = {
                  backgroundImage: `url(${content[key].fields.image.fields.file.url})`,
                }
                return (
                  <div className="um-okkur-staff-single" key={key}>
                    <div
                      key={key}
                      className="um-okkur-staff-image"
                      style={image}
                    />
                    <img
                      src={`${content[key].fields.image.fields.file.url}`}
                      className="um-okkur-staff-image-real"
                    />
                    <div className="um-okkur-staff-name">
                      {content[key].fields.name}
                    </div>
                    <div className="um-okkur-staff-description">
                      {content[key].fields.description}
                      <br />
                      <a
                        href={`mailto:${content[key].fields.email}`}
                        className="um-okkur-staff-email"
                      >
                        {content[key].fields.email}
                      </a>
                    </div>
                  </div>
                )
              })}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/about-us/um-okkur-employees/um-okkur-employees.tsx